import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiShield, FiZap, FiCode, FiLayers, FiTarget, FiCheckCircle, FiLink } = FiIcons;

const steps = [
  { label: '0a', title: 'Crawl Context', icon: FiZap },
  { label: '0b', title: 'SEO Title (as entered)', icon: FiTarget },
  { label: '0c', title: 'Keyword Angle', icon: FiTarget },
  { label: '0d', title: 'Review File Names', icon: FiLink },
  { label: '1', title: 'Spintax Template', icon: FiLayers },
  { label: '2', title: 'N × Spintax Resolve', icon: FiCode },
  { label: '3', title: 'Domain Verify', icon: FiShield },
  { label: '4', title: 'ZIP Export', icon: FiCheckCircle },
];

const StatsBar = ({ isGenerating, currentStep }) => (
  <div className="bg-slate-900 border border-slate-800 rounded-xl p-4">
    <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-3">
      Pipeline Steps
    </p>
    <div className="flex gap-2 flex-wrap">
      {steps.map((step, i) => (
        <div
          key={step.label}
          className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-mono border transition-all ${
            isGenerating && currentStep === i
              ? 'border-indigo-500 bg-indigo-950/40 text-indigo-300'
              : 'border-slate-800 text-slate-500'
          }`}
        >
          <span className="text-slate-600">{step.label}</span>
          <span>{step.title}</span>
        </div>
      ))}
    </div>
    
    <p className="text-xs text-green-600 mt-2 font-mono">
      ↳ Only 4 LLM calls total — titles + slugs + angle + spintax template. Pages resolved client-side.
    </p>
    <p className="text-xs text-violet-600 mt-0.5 font-mono">
      ↳ Cost is fixed regardless of page count (10 pages = same cost as 500 pages)
    </p>
  </div>
);

export default StatsBar;